import api from 'api';
import { errHelper } from 'utils';
import {
  setPastPerformance,
  setExistingPoliciesCharges,
  setPortfolioRiskScore,
  setExistingPoliciesRiskScore,
  setRecommendedPoliciesRiskScore,
  setExistingPoliciesPerformance,
  setAssetAllocations,
  setSectorBreakdown,
  setCountryBreakdown,
  setRegionalBreakdown
} from '../Case/actions';

export const existingPolicyAnalysisActions = {
  getPastPerfromanceData:
    ({ portfolio }: any) =>
    (dispatch: any) => {
      return Promise.all([
        api.getPastPerformanceData({ portfolio }),
        api.getExistingPoliciesPerformanceData({ portfolio })
      ]).then(([pastPerformance, existingPoliciesPerformance]) => {
        dispatch(setPastPerformance(pastPerformance.data));
        dispatch(
          setExistingPoliciesPerformance(existingPoliciesPerformance.data)
        );
      });
    },
  getExistingPolicyAnalysisData:
    ({ portfolio }: any) =>
    (dispatch: any) => {
      return Promise.all([
        api.getPortfolioRiskScore({ portfolio }),
        api.getExistingPoliciesRiskScore({ portfolio }),
        api.getRecommendedPoliciesRiskScore({ portfolio }),
        api.getExsitinPoliciesChargesData({ portfolio }),
        api.getAssetAllocationData({ portfolio }, 'existing'),
        api.getSectorBreakdownData({ portfolio }, 'existing'),
        api.getRegionalBreakdownData({ portfolio }, 'existing'),
        api.getCountryBreakdownData({ portfolio }, 'existing')
      ])
        .then(
          ([
            portfolioRiskScore,
            existingPoliciesRiskScore,
            recommendedPoliciesRiskScore,
            existingPoliciesCharges,
            assetAllocations,
            sectorBreakdown,
            regionalBreakdown,
            countryBreakdown
          ]) => {
            dispatch(setPortfolioRiskScore(portfolioRiskScore.data));
            dispatch(
              setExistingPoliciesRiskScore(existingPoliciesRiskScore.data)
            );
            dispatch(
              setRecommendedPoliciesRiskScore(recommendedPoliciesRiskScore.data)
            );
            dispatch(setExistingPoliciesCharges(existingPoliciesCharges.data));
            const preparedData = assetAllocations.data.filter(
              (allocation: any) => allocation.Existing !== 0
            );
            dispatch(setAssetAllocations(preparedData));
            dispatch(setSectorBreakdown(sectorBreakdown.data));
            dispatch(setRegionalBreakdown(regionalBreakdown.data));
            dispatch(setCountryBreakdown(countryBreakdown.data));
          }
        )

        .catch(err => {
          errHelper(err);
        });
    }
};
